import Axios from "middleware/axiosInstance"
import moments from 'moment'

// send token to server (route leaves) to check validation in response,
//  if token is valid, return false so if token invalid, return true
const checkUserAuthentication = async () => {
    const token = localStorage.getItem("token")
    if (token) {
        console.log("chekicg")
        return await Axios.get(`user/leaves?api_token=${token}`)
            .then(() => {
                return true
            })
            .catch((err) => {
                if (err.response.status === 401) {
                    console.log("catch")
                    return false
                } else {
                    alert("عملیات انجام نشد!");
                }
            });
    }
}

const convertTimeToStandartTime = (time) => {
    return `${moments(`${time.toLocaleTimeString("en-us")}`, 'hh:mm A').format('HH:mm')}:00`
}


export {
    checkUserAuthentication,
    convertTimeToStandartTime
}